'use client';
import React from 'react';
import { Settings } from 'react-slick';
import { Arrow } from '@/components/common/Carousel/Arrows';

const BREAKPOINTS = Object.freeze({
  small: 375,
  medium: 767,
  large: 1024,
  extraLarge: 1240,
});

export function generateSliderSettings(
  styleVariant?: 'quoteCard' | 'valueProp',
) {
  // WARNING - center mode does not behave well with an even number of slides
  // see https://github.com/kenwheeler/slick/issues/2795
  const defaultSettings: Settings = {
    nextArrow: <Arrow direction="right" />,
    prevArrow: <Arrow direction="left" />,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: true,
    className: 'luv-carousel',
    responsive: [
      {
        breakpoint: BREAKPOINTS.medium,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '8px',
          swipeToSlide: true,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  switch (styleVariant) {
    case 'valueProp':
      const valuePropSettings: Settings = {
        responsive: [
          {
            breakpoint: BREAKPOINTS.medium,
            settings: {
              slidesToShow: 1,
              swipeToSlide: true,
              arrows: true,
              infinite: true,
            },
          },
        ],
      };

      return { ...defaultSettings, ...valuePropSettings };
    case 'quoteCard':
      const quoteCardSettings: Settings = {
        className: `${defaultSettings.className} lg:container lg:mx-auto`,
        responsive: [
          {
            breakpoint: BREAKPOINTS.medium,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '36px',
              swipeToSlide: true,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: BREAKPOINTS.large,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '140px',
              swipeToSlide: true,
              dots: true,
              arrows: false,
            },
          },
        ],
      };

      return { ...defaultSettings, ...quoteCardSettings };
    default:
      return defaultSettings;
  }
}
